'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CalendarInfoPositionShape = {};

exports.__exports = CalendarInfoPositionShape;
